import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.js";
import "./App.css"; // <-- TEN IMPORT JEST KLUCZOWY

ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
